var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4621 5.89024C10.4858 5.61511 10.728 5.41129 11.0031 5.43498C12.2778 5.54474 13.2761 5.9367 13.9385 6.75309C14.5897 7.55568 14.8402 8.67735 14.8402 10.0731V10.1598C14.8402 11.6993 14.535 12.9071 13.7246 13.7175C12.9142 14.5279 11.7063 14.8331 10.1669 14.8331H5.8269C4.28745 14.8331 3.0796 14.5279 2.26918 13.7175C1.45876 12.9071 1.15356 11.6993 1.15356 10.1598V10.0731C1.15356 8.68749 1.4007 7.57257 2.04146 6.77162C2.69379 5.95622 3.67752 5.55907 4.93382 5.44196C5.20877 5.41633 5.45244 5.61844 5.47807 5.89339C5.5037 6.16834 5.30159 6.41201 5.02664 6.43764C3.92294 6.54053 3.24334 6.87005 2.82233 7.39632C2.38976 7.93703 2.15356 8.77878 2.15356 10.0731V10.1598C2.15356 11.6004 2.44504 12.4792 2.97628 13.0104C3.50753 13.5417 4.38635 13.8331 5.8269 13.8331H10.1669C11.6074 13.8331 12.4863 13.5417 13.0175 13.0104C13.5488 12.4792 13.8402 11.6004 13.8402 10.1598V10.0731C13.8402 8.76892 13.6007 7.92392 13.162 7.38318C12.7344 6.85623 12.0427 6.5282 10.9173 6.43129C10.6422 6.4076 10.4384 6.16536 10.4621 5.89024Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.833496C8.27614 0.833496 8.5 1.05735 8.5 1.3335V9.92016C8.5 10.1963 8.27614 10.4202 8 10.4202C7.72386 10.4202 7.5 10.1963 7.5 9.92016V1.3335C7.5 1.05735 7.72386 0.833496 8 0.833496Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41354 8.07955C5.6088 7.88429 5.92538 7.88429 6.12064 8.07955L8.00042 9.95933L9.8802 8.07955C10.0755 7.88429 10.392 7.88429 10.5873 8.07955C10.7826 8.27481 10.7826 8.5914 10.5873 8.78666L8.35398 11.02C8.15871 11.2153 7.84213 11.2153 7.64687 11.02L5.41354 8.78666C5.21827 8.5914 5.21827 8.27481 5.41354 8.07955Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.94011581acc784314bd6d8532f3bfb3d.svg";
export { ForwardRef as ReactComponent };